import SegmentedControl from "@/components/forms/SegmentedControl";

export const PaymentMode = {
  insurance: "insurance",
  cash: "cash",
} as const;
export type PaymentMode = (typeof PaymentMode)[keyof typeof PaymentMode];

type PaymentModeToggleProps = {
  value: PaymentMode;
  onChange: (value: PaymentMode) => void;
  insuranceDisabled: boolean;
};

const PaymentModeToggle = ({
  value,
  onChange,
  insuranceDisabled,
}: PaymentModeToggleProps) => (
  <SegmentedControl
    value={value}
    onChange={onChange}
    dataTrackingId="visit-options-payment-mode"
    options={[
      {
        value: PaymentMode.insurance,
        label: "Insurance",
        disabled: insuranceDisabled,
      },
      {
        value: PaymentMode.cash,
        label: "Cash Pay",
      },
    ]}
  />
);

export default PaymentModeToggle;
